import { ChannelPayloadFilter, ViewStream } from "spyne";

export class UiBreadcrumbItem extends ViewStream {
  constructor(props = {}) {
    props.tagName = "li";
    props.class = `ui-breadcrumb-item ${props.data.menuLabel}`;

    const addDatasetProp = () => {};
    /*

        props.dataset = {};
        for (const k in props.data.breadcrumbItemDataset){

          props.dataset[k] = props.data.breadcrumbItemDataset[k];

        }
*/

    //   props.data = props.data.breadcrumbItemDataset;

    //props.dataset = props.data.breadcrumbItemDataset;

    props.template = require("./templates/ui-breadcrumb-item.tmpl.html");
    super(props);
  }

  addActionListeners() {
    /**
     * TODO: If breadcrumb does not match current level and data, then remove itself
     *
     * */

    const { contentLevel } = this.props.data.menuData;
    const payloadFilter = new ChannelPayloadFilter({
      payload: (v) => v.docsBreadcrumbData.lastLevelNum >= contentLevel,
    });
    // return nexted array(s)
    return [["CHANNEL_APP_ROUTE_CARD_CHANGE_EVENT", "onDocsItemChanged"]];
  }

  onDocsItemChanged(e) {
    const { payload } = e;
    const { itemId } = payload;

    //console.log("DOCS ITEM CHANGED ",{payload, itemId}, this.props);
    this.disposeViewStream();
  }

  broadcastEvents() {
    // return nexted array(s)
    return [["a", "click"]];
  }

  onRendered() {
    /* for (const k in this.props.data.breadcrumbItemDataset){

        this.props.el.dataset[k] = this.props.data.breadcrumbItemDataset[k];

      }*/

    //console.log("breadcrumb item data after", this.props.el.dataset);

    this.addChannel("CHANNEL_APP_ROUTE", true);
  }
}
